import { Button, Col, Modal, Row } from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useIntl } from "react-intl";
import { CODE, DEFAULT_PAGE_INDEX, KEY, MAX_PAGE_SIZE, TYPE_WH, WF_TRACKER } from "../../../../utils/Constant";
import { toast } from "react-toastify";
import { XayDungKeHoachContext } from "../DanhSachKeHoach";
import { formatDateDTO } from "../../../../utils/FormatUtils";
import { AppContext } from "../../../../appContext/AppContext";
import { OctGenerateForm } from "@oceantech/oceantech-ui";
import ButtonIn from "../../../../component/button-in-phieu";
import { IconButtonSave } from "../../../../component/IconSvg";
import WfButton from "../../../../workflows/components/WfButton";
import TableThongTinKyThuatChuyenGiao from "./TableThongTinKyThuatChuyenGiao";
import FormThemThongTinChuyenGiao from "./FormThemThongTinChuyenGiao";
import { TypeKeHoach } from "../models/KeHoachModel";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import { CODE_KE_HOACH, TYPE_KE_HOACH, WMS_STATUS } from "../constants/constansKeHoach";
import {
  addPhieuKeHoach,
  updatePhieuKeHoach
} from "../../../../quan-ly-chi-dao-tuyen/Components/xay-dung-ke-hoach/services/services";
import { getPhieuKeHoach, getStaffList } from "../services/services";
import { TYPE_CDT } from "../../../../ho-tro-ky-thuat/const/hoTroKyThuat";
import LabelRequired from "../../../../component/LabelRequired";
import TableNhanLuc from "../../../../quan-ly-chi-dao-tuyen/Components/co-so-kb-cb/components/TableNhanLuc";
import {
  searchOptionNhanVien,
  searchOptionVaiTro
} from "../../../../quan-ly-chi-dao-tuyen/Components/co-so-kb-cb/services/services";
import {
  getKhaoSatById,
  searchPhieuKhaoSat
} from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/services/services";
import { STATUS_PLAN_SLIP } from "../../../const/QuanLyCDT";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  lstWarehouse: any;
}

// Constants cho các loại nhân lực
const NHAN_LUC_TYPE = {
  CHUYEN_GIAO: 'CHUYEN_GIAO',
  TIEP_NHAN: 'TIEP_NHAN',
  HO_TRO: 'HO_TRO',
};

const DialogPhieuNhapKho = (props: Props) => {
  const { show, onHide, warehouseId, setInitialValues, initialValues, lstWarehouse } = props;
  const [type, setType] = useState<TypeKeHoach | null>(null);
  const { setIsLoading } = useContext(AppContext);
  const { dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach } = useContext(XayDungKeHoachContext);
  const intl = useIntl();
  const [isView, setIsView] = useState<boolean>(!!detailPhieuKeHoach.id);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);
  const [formKey, setFormKey] = useState(0);

  // Đổi cấu trúc dataNhanLuc - chỉ sử dụng batchStaffList với type
  const [dataNhanLuc, setDataNhanLuc] = useState<any>({
    batchStaffList: [],
  });
  const [thanhVien, setThanhVien] = useState<any>([]);

  const [selectedNhanSuTren, setSelectedNhanSuTren] = useState<any>(null);
  const [selectedTiepNhanHoTro, setSelectedTiepNhanHoTro] = useState<any>(null);
  const [selectedCanBoHoTro, setSelectedCanBoHoTro] = useState<any>(null);
  const [selectedKhaoSat, setSelectedKhaoSat] = useState<any>(null);
  const [optionsKhaoSat, setOptionsKhaoSat] = useState<any>([]);
  const [editingIndexTren, setEditingIndexTren] = useState<number | null>(null);
  const [editingType, setEditingType] = useState<string | null>(null);

  const getOptions = async () => {
    if (!type?.type) return;
    try {
      setIsLoading(true);
      const requests = [
        searchOptionNhanVien({ pageSize: MAX_PAGE_SIZE }),
      ];

      if (type?.code !== CODE_KE_HOACH.KHHC) {
        requests.push(
          searchPhieuKhaoSat({
            pageSize: MAX_PAGE_SIZE,
            type: type?.typeKhaoSat,
            trackerCode: type?.trackerCodeKhaoSat,
          })
        );
      }

      const [nhanVien, khaoSat] = await Promise.all(requests);

      setThanhVien(nhanVien?.data?.data?.content ?? []);
      if (khaoSat) {
        setOptionsKhaoSat(khaoSat?.data?.data?.content ?? []);
      }
    } catch (e) {
      console.error("Lỗi khi tải danh sách:", e);
    } finally {
      setIsLoading(false);
    }
  };

  // Hàm thêm hoặc cập nhật nhân lực theo type
  const handleAddOrUpdate = (itemSelected: any, staffType: string) => {
    if (handlerSelectItem(itemSelected, getItemsByType(staffType))) return
    const newItem = {
      personnel: itemSelected?.code || "",
      personnelName: itemSelected?.name || "",
      position: itemSelected?.position || "",
      positionName: itemSelected?.chucVu || "",
      unit: itemSelected?.unitName || itemSelected?.department || "",
      unitName: itemSelected?.unitName || itemSelected?.department || "",
      degree: "",
      degreeName: "",
      experience: "",
      currentCapacity: "",
      currentCapacityName: "",
      item: itemSelected,
      levelType: staffType, // Thêm type để phân biệt
    };

    let updatedList = [...dataNhanLuc.batchStaffList];

    if (editingIndexTren !== null && editingType === staffType) {
      // Tìm index thực tế trong batchStaffList
      const itemsOfType = updatedList.filter(item => item.type === staffType);
      const actualIndex = updatedList.findIndex(item =>
        item.levelType === staffType && itemsOfType.indexOf(item) === editingIndexTren
      );
      if (actualIndex !== -1) {
        updatedList[actualIndex] = newItem;
      }
      setEditingIndexTren(null);
      setEditingType(null);
    } else {
      updatedList = [newItem, ...updatedList];
    }

    setDataNhanLuc({ batchStaffList: updatedList });

    // Reset các selected state
    setSelectedNhanSuTren(null);
    setSelectedTiepNhanHoTro(null);
    setSelectedCanBoHoTro(null);
  };

  // Hàm xóa nhân lực theo type
  const handleDelete = (index: number, staffType: string) => {
    const itemsOfType = dataNhanLuc.batchStaffList.filter((item: any) => item.levelType === staffType);
    const itemToDelete = itemsOfType[index];
    const updatedList = dataNhanLuc.batchStaffList.filter((item: any) => item !== itemToDelete);

    setDataNhanLuc({ batchStaffList: updatedList });
    toast.success('Xóa thành công');
  };

  // Hàm lấy danh sách theo type
  const getItemsByType = (staffType: string) => {
    return dataNhanLuc.batchStaffList.filter((item: any) => item.levelType === staffType);
  };

  useEffect(() => {
    getOptions();
  }, [type?.type]);

  const handleAddItem = async (values: any) => {
    if (!type?.formVatTu) return;
    const dataItem = values[type.formVatTu] || {};
    let newLstItem = [...dsKeHoach];
    if (indexRowEdit === null) {
      newLstItem = [...newLstItem, { ...dataItem, item: dataItem.item || dataItem, id: null, type: type?.type }];
    } else {
      newLstItem[indexRowEdit] = {
        ...dataItem,
        item: dataItem.item || dataItem,
        id: newLstItem[indexRowEdit].id,
        type: type?.type
      };
    }
    setIndexRowEdit(null);
    setInitialValuesFormThemVT(generateInitValues(listJsonGenerateVT));
    setDsKeHoach(newLstItem);
    setFormKey(prev => prev + 1);
  };

  const handleFormSubmit = async (values: any) => {
    if (!type) return;
    if (!dsKeHoach?.length) {
      toast.warning('Chưa có thông tin chuyển giao');
      return;
    }
    if (type?.code !== CODE_KE_HOACH.KHHC && !selectedKhaoSat?.id) {
      toast.warning('Chưa chọn phiếu khảo sát');
      return;
    }
    const dataSubmit = {
      slipDto: {
        ...values?.[type?.formThongTinChung || ''],
        doCreation: values?.[type?.formThongTinChung || '']?.id ? formatDateDTO(values?.[type?.formThongTinChung || '']?.doCreation) : formatDateDTO(new Date()),
        type: type?.type,
        typeCTD: TYPE_CDT.TECHNICAL_TRANSFER,
        surveyId: selectedKhaoSat?.id,
      },
      techTransferInfoList: [...(dsKeHoach || [])].map(item => {
        return (
          {
            itemId: item?.item?.id,
            ...item?.item,
            ...item,
            id: item?.id || null,
            expectedSessions: 3,
          }
        )
      }),
      batchStaffList: dataNhanLuc.batchStaffList, // Gửi toàn bộ batchStaffList với type
      trackerCode: type.trackerCode,
      termModelType: type?.formThongTinChung,
    };

    try {
      setIsLoading(true);
      const id = values?.[type?.formThongTinChung || '']?.id;
      const { data } = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);

      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        setDetailPhieuKeHoach({
          ...data?.data,
          statusId: detailPhieuKeHoach.statusId,
        });
        getSelectedRowsData(data?.data?.id);
        toast.success(((id) ? "Cập nhật" : "Thêm") + " phiếu thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getSelectedRowsData = async (id: string) => {
    try {
      setIsLoading(true);
      const { data } = await getPhieuKeHoach(id);
      setDsKeHoach(data?.data || []);
      const staffs = await getStaffList(id);
      setDataNhanLuc({ batchStaffList: staffs?.data?.data ?? [] });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getSurvey = async () => {
    if (!initialValues?.surveyId) return;
    try {
      const survey = await getKhaoSatById(initialValues?.surveyId);
      setSelectedKhaoSat(survey?.data?.data)
    } catch (e) {

    }
  }
  useEffect(() => {
    if (initialValues?.id) {
      const typeExist: TypeKeHoach | undefined = TYPE_KE_HOACH.find((x: any) => x?.type === initialValues?.type)
      if (typeExist) {
        setType(typeExist)
      }
      getSelectedRowsData(initialValues?.id);
    }
  }, [initialValues?.id]);

  useEffect(() => {
    getSurvey()
  }, [initialValues?.surveyId]);

  useEffect(() => {
    if (!type?.code) return;
    updateForm();
    updateFormVatTu();
  }, [type?.code]);

  const updateFormVatTu = async () => {
    if (!type?.formVatTu) return;
    const data = await generateForm(type?.formVatTu, setIsLoading);
    setListJsonGenerateVT(data || []);
    setInitialValuesFormThemVT(generateInitValues(data));
  };

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({ [type?.formThongTinChung]: { ...generateInitValues(data), ...initialValues ?? {} } });
  };

  // Tạo columns động cho bảng theo type
  const createColumnsForTable = (staffType: string) => [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleDelete(index, staffType)}
                className="bi bi-trash3-fill text-danger cursor-pointer"
                style={{ cursor: 'pointer' }}
                title="Xóa"
              ></i>
            </div>
        },
      ] : []),
    {
      name: "Họ tên",
      field: "personnelName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.personnelName || row.item?.personnelName || '',
    },
    {
      name: "Chức danh",
      field: "position",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.position || row.item?.position || '',
    },
    {
      name: "Đơn vị",
      field: "unitName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.unitName || row.item?.unitName || '',
    },
    {
      name: "Trình độ chuyên môn",
      field: "quantityOfficer",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any) => row.quantityOfficer || row.item?.quantityOfficer || '',
    },
  ];

  const handlerSelectItem = (item: any, lst: any) => {
    const isDuplicate = lst.some((items: any) => items?.item.code === item.code);
    if (isDuplicate) {
      toast.warning("Đã có nhân sự này!");
      return true
    }
  }
  return (
    <Modal
      centered
      show={show}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-phieu-khao-sat"
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={generateValidationSchema(listJsonGenerate, type?.formThongTinChung || "")}
        onSubmit={handleFormSubmit}
      >
        {({ values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Modal.Header className="header-modal min-h-40px">
                <div className="d-flex gap-6">
                  <div
                    className="d-flex align-items-center title-back gap-3 cursor-pointer"
                    onClick={onHide}
                  >
                    <i className="spaces bi bi-chevron-left ml-10"></i>
                    <div className="spaces mr-20 my-3">Quay lại</div>
                  </div>
                  <div className="spaces mt-4 title">
                    {`${values?.[type?.formThongTinChung ?? '']?.id ? 'Cập nhật' : 'Thêm mới'} kế hoạch`}
                  </div>
                </div>
              </Modal.Header>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <h4 className="title spaces mb-5 pt-10">Loại kế hoạch</h4>
                  <div className="d-flex">
                    <AutocompleteObjectV2
                      options={TYPE_KE_HOACH}
                      isSearchDefauilt={true}
                      name={"planType"}
                      value={type}
                      onChange={(option) => {
                        setType(option)
                        setDsKeHoach([])
                      }}
                      disabled={isView}
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                    />
                  </div>
                  <div className="spaces fw-bold">
                    <hr />
                  </div>
                </div>



                {/* Phần khảo sát */}
                {type?.code && type?.code !== CODE_KE_HOACH.KHHC &&
                  <div className="spaces px-10">
                    {/* <h4 className="text-title fw-bold fs-5 spaces mb-5">
                      Khảo sát
                    </h4> */}
                    <Row>
                      <Col lg={1} className="spaces">
                        <div className="spaces pt-10 min-w-135">
                          <div className="spaces mt-1">
                            <LabelRequired isRequired className="min-w-100px" label="Phiếu khảo sát" />
                          </div>
                        </div>
                      </Col>
                      <Col lg={11} className="spaces">
                        <AutocompleteObjectV2
                          options={optionsKhaoSat}
                          value={selectedKhaoSat}
                          isSearchDefauilt={true}
                          name="WmsCode"
                          onChange={(options: any) => setSelectedKhaoSat(options)}
                          className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                          isClearable={true}
                          disabled={isView}
                          placeholder="Chọn phiếu khảo sát..."
                        />
                      </Col>
                    </Row>
                  </div>
                }


                {type?.code && <>
                  <div className="spaces px-10">
                    <OctGenerateForm
                      isView={isView}
                      listFieldAuto={listJsonGenerate}
                      handleChange={handleChange}
                      setValues={setValues}
                      values={values}
                      touched={touched}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      modelID={type?.formThongTinChung}
                    />
                    <div className="spaces fw-bold">
                      <hr />
                    </div>
                    <Formik
                      key={formKey}
                      enableReinitialize
                      validateOnChange={true}
                      validateOnBlur={true}
                      initialValues={{
                        [type.formVatTu]: {
                          ...initialValuesFormThemVT,
                        }
                      }}
                      validationSchema={generateValidationSchema(listJsonGenerateVT, type.formVatTu)}
                      onSubmit={handleAddItem}
                    >
                      <FormThemThongTinChuyenGiao
                        LST_WAREHOUSE={lstWarehouse}
                        type={type}
                        listJsonGenerateVT={listJsonGenerateVT}
                        generalValues={values}
                        setGeneralFieldValue={setFieldValue}
                        dsNhapKho={dsKeHoach}
                        setDsNhapKho={setDsKeHoach}
                        warehouseId={warehouseId}
                        isView={isView}
                        indexRowEdit={indexRowEdit}
                        setIndexRowEdit={setIndexRowEdit}
                        initialValuesFormThemVT={initialValuesFormThemVT}
                        setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                      />
                    </Formik>
                    <TableThongTinKyThuatChuyenGiao
                      type={type}
                      isView={isView}
                      setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                      indexRowEdit={indexRowEdit}
                      setIndexRowEdit={setIndexRowEdit}
                    />
                  </div>

                  {/* Bảng Nhân lực thực hiện chuyển giao */}
                  {type?.code === CODE_KE_HOACH.KHCG && <div className="spaces px-10">
                    <h4 className="text-title fw-bold fs-5 spaces mb-5">
                      Nhân lực thực hiện chuyển giao
                    </h4>
                    {!isView && (
                      <Row>
                        <Col lg={1} className="spaces">
                          <div className="spaces pt-10 min-w-135">
                            <div className="spaces mt-1">
                              <LabelRequired className="min-w-100px" label="Nhân sự" />
                            </div>
                          </div>
                        </Col>
                        <Col lg={10} className="spaces">
                          <AutocompleteObjectV2
                            options={thanhVien}
                            value={selectedNhanSuTren}
                            isSearchDefauilt={true}
                            name="WmsCode"
                            onChange={(options: any) => setSelectedNhanSuTren(options)}
                            className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                            isClearable={true}
                            placeholder="Chọn nhân sự..."
                          />
                        </Col>
                        <Col lg={1}>
                          <div className="d-flex mt-8 spaces align-items-center">
                            <Button
                              className="btn-fill spaces min-w-90px btn btn-primary"
                              onClick={() => handleAddOrUpdate(selectedNhanSuTren, NHAN_LUC_TYPE.CHUYEN_GIAO)}
                              type="button"
                            >
                              <i className="bi bi-plus-lg text-pri fs-3"></i>
                              {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    )}
                    <TableNhanLuc
                      columns={createColumnsForTable(NHAN_LUC_TYPE.CHUYEN_GIAO)}
                      isView={isView}
                      dsItems={getItemsByType(NHAN_LUC_TYPE.CHUYEN_GIAO)}
                    />
                  </div>}

                  {/* Bảng Đối tượng tiếp nhận và Cán bộ hỗ trợ */}
                  {type?.code === CODE_KE_HOACH.KHHT && <div className="spaces px-10">
                    <h4 className="text-title fw-bold fs-5 spaces mb-5">
                      Đối tượng tiếp nhận hỗ trợ kỹ thuật chuyên môn
                    </h4>
                    {!isView && (
                      <Row>
                        <Col lg={1} className="spaces">
                          <div className="spaces pt-10 min-w-135">
                            <div className="spaces mt-1">
                              <LabelRequired className="min-w-100px" label="Nhân sự" />
                            </div>
                          </div>
                        </Col>
                        <Col lg={10} className="spaces">
                          <AutocompleteObjectV2
                            options={thanhVien}
                            value={selectedTiepNhanHoTro}
                            isSearchDefauilt={true}
                            name="WmsCode"
                            onChange={(options: any) => setSelectedTiepNhanHoTro(options)}
                            className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                            isClearable={true}
                            placeholder="Chọn nhân sự..."
                          />
                        </Col>
                        <Col lg={1}>
                          <div className="d-flex mt-8 spaces align-items-center">
                            <Button
                              className="btn-fill spaces min-w-90px btn btn-primary"
                              onClick={() => handleAddOrUpdate(selectedTiepNhanHoTro, NHAN_LUC_TYPE.TIEP_NHAN)}
                              type="button"
                            >
                              <i className="bi bi-plus-lg text-pri fs-3"></i>
                              {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    )}
                    <TableNhanLuc
                      columns={createColumnsForTable(NHAN_LUC_TYPE.TIEP_NHAN)}
                      isView={isView}
                      dsItems={getItemsByType(NHAN_LUC_TYPE.TIEP_NHAN)}
                    />

                    <h4 className="text-title fw-bold fs-5 spaces mb-5">
                      Cán bộ hỗ trợ kỹ thuật chuyên môn
                    </h4>
                    {!isView && (
                      <Row>
                        <Col lg={1} className="spaces">
                          <div className="spaces pt-10 min-w-135">
                            <div className="spaces mt-1">
                              <LabelRequired className="min-w-100px" label="Nhân sự" />
                            </div>
                          </div>
                        </Col>
                        <Col lg={10} className="spaces">
                          <AutocompleteObjectV2
                            options={thanhVien}
                            value={selectedCanBoHoTro}
                            isSearchDefauilt={true}
                            name="WmsCode"
                            onChange={(options: any) => setSelectedCanBoHoTro(options)}
                            className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                            isClearable={true}
                            placeholder="Chọn nhân sự..."
                          />
                        </Col>
                        <Col lg={1}>
                          <div className="d-flex mt-8 spaces align-items-center">
                            <Button
                              className="btn-fill spaces min-w-90px btn btn-primary"
                              onClick={() => handleAddOrUpdate(selectedCanBoHoTro, NHAN_LUC_TYPE.HO_TRO)}
                              type="button"
                            >
                              <i className="bi bi-plus-lg text-pri fs-3"></i>
                              {editingIndexTren !== null ? 'Cập nhật' : 'Thêm'}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    )}
                    <TableNhanLuc
                      columns={createColumnsForTable(NHAN_LUC_TYPE.HO_TRO)}
                      isView={isView}
                      dsItems={getItemsByType(NHAN_LUC_TYPE.HO_TRO)}
                    />
                  </div>}


                </>}
              </Modal.Body>
              {type?.code &&
                <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                  {(values.nhapKho?.id || detailPhieuKeHoach?.id) && (
                    <WfButton
                      additionalFunc={(data: any) => {
                        setDetailPhieuKeHoach({
                          ...detailPhieuKeHoach,
                          status: data?.currCode,
                          statusCode: data?.currCode,
                          statusId: data?.currId,
                        })
                        if (data?.currCode == STATUS_PLAN_SLIP.LUU_MOI) {
                          setIsView(false)
                        } else {
                          setIsView(true)
                        }
                      }}
                      handleClick={(data: any) => {
                        data.code === "allowed-edit" && setIsView(false);
                      }}
                      tracker={type.trackerCode}
                      objectId={values?.[type?.formThongTinChung]?.id || detailPhieuKeHoach?.id}
                    />
                  )}
                  {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                      <IconButtonSave /> Lưu
                    </Button>
                  }
                  {(detailPhieuKeHoach?.id && type.pathApiPrint) &&
                    <ButtonIn
                      className="spaces min-w-120 mx-3"
                      endpoint={type.pathApiPrint}
                      params={{
                        slipId: detailPhieuKeHoach?.id,
                      }}
                    />
                  }
                </div>}
            </Form>
          )
        }}
      </Formik>
    </Modal>
  );
};

export default DialogPhieuNhapKho;